 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"widget": 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"widget": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"iframe-config-provider":"iframe-config-provider","url-config-provider":"url-config-provider","vendors~browsermock":"vendors~browsermock","browsermock":"browsermock","vendors~campaign-preview-app~widget-app":"vendors~campaign-preview-app~widget-app","widget-app":"widget-app","vendors~1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~article~banner~campaign-p~2ab1e55f":"vendors~1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~article~banner~campaign-p~2ab1e55f","1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~banner~carousel~carousel169~carou~1f6ab600":"1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~banner~carousel~carousel169~carou~1f6ab600","1x3~3x1hscroll~3x1list~3x1stacked~3x1stackedland~banner~frontoffice4X1~latimes2X1~popsugar-widget~sca-3x1":"1x3~3x1hscroll~3x1list~3x1stacked~3x1stackedland~banner~frontoffice4X1~latimes2X1~popsugar-widget~sca-3x1","1x3":"1x3","3x1list":"3x1list","vendors~3x1hscroll~3x1simple~3x1stacked~3x1stackedland~article~banner~campaign-preview-app~carousel~~4031e2e2":"vendors~3x1hscroll~3x1simple~3x1stacked~3x1stackedland~article~banner~campaign-preview-app~carousel~~4031e2e2","3x1hscroll":"3x1hscroll","3x1stacked":"3x1stacked","3x1stackedland":"3x1stackedland","banner":"banner","frontoffice4X1":"frontoffice4X1","latimes2X1":"latimes2X1","popsugar-widget":"popsugar-widget","sca-3x1":"sca-3x1","3x1simple":"3x1simple","vendors~adblock~article~campaign-preview-app~carousel~carousel169~carousel169animated~carousel169aut~a484999e":"vendors~adblock~article~campaign-preview-app~carousel~carousel169~carousel169animated~carousel169aut~a484999e","carousel":"carousel","carousel169":"carousel169","carousel169animated":"carousel169animated","carousel169auto":"carousel169auto","cbsnews3x1":"cbsnews3x1","floating-carousel":"floating-carousel","forced-carousel":"forced-carousel","icarousel169":"icarousel169","mtv3x1":"mtv3x1","sca-carousel":"sca-carousel","sca-icarousel":"sca-icarousel","vendors~article":"vendors~article","article":"article","iabc":"iabc","vendors~adblock":"vendors~adblock","adblock":"adblock","amp":"amp","vendors~disco-logo":"vendors~disco-logo","disco-logo":"disco-logo"}[chunkId]||chunkId) + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"widget-app":1,"1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~banner~carousel~carousel169~carou~1f6ab600":1,"1x3~3x1hscroll~3x1list~3x1stacked~3x1stackedland~banner~frontoffice4X1~latimes2X1~popsugar-widget~sca-3x1":1,"1x3":1,"3x1list":1,"3x1hscroll":1,"3x1stacked":1,"3x1stackedland":1,"banner":1,"frontoffice4X1":1,"latimes2X1":1,"popsugar-widget":1,"sca-3x1":1,"3x1simple":1,"carousel":1,"carousel169":1,"carousel169animated":1,"carousel169auto":1,"cbsnews3x1":1,"floating-carousel":1,"forced-carousel":1,"icarousel169":1,"mtv3x1":1,"sca-carousel":1,"sca-icarousel":1,"article":1,"iabc":1,"adblock":1,"disco-logo":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"iframe-config-provider":"iframe-config-provider","url-config-provider":"url-config-provider","vendors~browsermock":"vendors~browsermock","browsermock":"browsermock","vendors~campaign-preview-app~widget-app":"vendors~campaign-preview-app~widget-app","widget-app":"widget-app","vendors~1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~article~banner~campaign-p~2ab1e55f":"vendors~1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~article~banner~campaign-p~2ab1e55f","1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~banner~carousel~carousel169~carou~1f6ab600":"1x3~3x1hscroll~3x1list~3x1simple~3x1stacked~3x1stackedland~adblock~banner~carousel~carousel169~carou~1f6ab600","1x3~3x1hscroll~3x1list~3x1stacked~3x1stackedland~banner~frontoffice4X1~latimes2X1~popsugar-widget~sca-3x1":"1x3~3x1hscroll~3x1list~3x1stacked~3x1stackedland~banner~frontoffice4X1~latimes2X1~popsugar-widget~sca-3x1","1x3":"1x3","3x1list":"3x1list","vendors~3x1hscroll~3x1simple~3x1stacked~3x1stackedland~article~banner~campaign-preview-app~carousel~~4031e2e2":"vendors~3x1hscroll~3x1simple~3x1stacked~3x1stackedland~article~banner~campaign-preview-app~carousel~~4031e2e2","3x1hscroll":"3x1hscroll","3x1stacked":"3x1stacked","3x1stackedland":"3x1stackedland","banner":"banner","frontoffice4X1":"frontoffice4X1","latimes2X1":"latimes2X1","popsugar-widget":"popsugar-widget","sca-3x1":"sca-3x1","3x1simple":"3x1simple","vendors~adblock~article~campaign-preview-app~carousel~carousel169~carousel169animated~carousel169aut~a484999e":"vendors~adblock~article~campaign-preview-app~carousel~carousel169~carousel169animated~carousel169aut~a484999e","carousel":"carousel","carousel169":"carousel169","carousel169animated":"carousel169animated","carousel169auto":"carousel169auto","cbsnews3x1":"cbsnews3x1","floating-carousel":"floating-carousel","forced-carousel":"forced-carousel","icarousel169":"icarousel169","mtv3x1":"mtv3x1","sca-carousel":"sca-carousel","sca-icarousel":"sca-icarousel","vendors~article":"vendors~article","article":"article","iabc":"iabc","vendors~adblock":"vendors~adblock","adblock":"adblock","amp":"amp","vendors~disco-logo":"vendors~disco-logo","disco-logo":"disco-logo"}[chunkId]||chunkId) + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				(function addStylesToDom(element) {
 				  window.disco = window.disco || {};

 				  // this function is saved to the window object and is called by the application code
 				  // in order to reduce code duplication and errors.  since this file is not
 				  // processed by webpack, the code here can't easily live in a common module
 				  // that can be imported where needed
 				  window.disco._addStyleElement =
 				    window.disco._addStyleElement ||
 				    function (styleElement, injectionPoint) {
 				      // helper to check if root is defined before injecting element
 				      function inject(el, root) {
 				        if (root && el) {
 				          root.appendChild(el);
 				        }
 				      }
 				      const installedStyles = window.disco._installedStyles || [];
 				      const isAlreadyInstalled = installedStyles.indexOf(styleElement) >= 0;

 				      const injectionPoints = Array.isArray(injectionPoint)
 				        ? injectionPoint
 				        : injectionPoint instanceof NodeList ||
 				          injectionPoint instanceof HTMLCollection
 				        ? Array.from(injectionPoint)
 				        : [injectionPoint];

 				      if (
 				        (styleElement.href &&
 				          styleElement.href.toLowerCase().includes('font')) ||
 				        window.STORYBOOK_ENV !== undefined ||
 				        (styleElement.tagName !== 'STYLE' && styleElement.tagName !== 'LINK')
 				      ) {
 				        document.head.appendChild(styleElement);
 				      } else {
 				        if (injectionPoints.length === 0) return;

 				        if (styleElement.tagName === 'LINK') {
 				          // links can just be cloned and added to the dom. the original styleElement
 				          // can only be added to the dom once, after which clones will have to be used
 				          let copy = !isAlreadyInstalled
 				            ? styleElement
 				            : styleElement.cloneNode(true);

 				          for (const ip of injectionPoints) {
 				            inject(copy, ip.shadowRoot);
 				            copy = styleElement.cloneNode(true);
 				          }
 				        } else {
 				          // element is a style tag.  MutationObservers need to be setup to propagate
 				          // changes from the original element to all clones as styles seem to be added
 				          // to the tags asynchronously. the tags are initially empty

 				          const nClones = isAlreadyInstalled
 				            ? injectionPoints.length
 				            : injectionPoints.length - 1;
 				          const clones = Array(nClones)
 				            .fill(0)
 				            .map(() => styleElement.cloneNode(true));

 				          if (clones.length > 0) {
 				            const observer = new MutationObserver(() => {
 				              clones.forEach((clone) => {
 				                clone.textContent = styleElement.textContent;
 				              });
 				            });
 				            observer.observe(styleElement, { childList: true });
 				          }

 				          for (let i = 0, j = 0; i < injectionPoints.length; i += 1) {
 				            if (i === 0 && !isAlreadyInstalled) {
 				              inject(styleElement, injectionPoints[i].shadowRoot);
 				            } else {
 				              inject(clones[j], injectionPoints[i].shadowRoot);
 				              j += 1;
 				            }
 				          }
 				        }
 				      }
 				    };

 				  const injectionPoints =
 				    (window && window.disco && window.disco._injectionPoints) ||
 				    document.querySelectorAll('.disco-widget');

 				  window.disco._addStyleElement(element, injectionPoints);

 				  window.disco._installedStyles = window.disco._installedStyles || [];
 				  window.disco._installedStyles.push(element);
 				})(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://disco.headliner.link/artifacts/web/4.23.0-77/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonpdisco-web"] = this["webpackJsonpdisco-web"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = "./src/apps/widget/index.tsx");
